import styled from '@emotion/styled';

export const ContainerImageWrapper = styled.div`
  display: flex;
  height: 100px;
`;
